export default __webpack_public_path__ + "static/media/819.23c26f63.gif";